import React from 'react'
import Toolbar from 'material-ui/Toolbar'
import StockBalanceExport from './StockBalanceExportContainer'
import Button from 'material-ui/Button'
import AddIcon from 'material-ui-icons/Add'
import { withStyles } from 'material-ui/styles'

const styles = theme => ({
  button: {
    margin: theme.spacing.unit
  }
})

const JobListMenuBar = ({classes, handleNewJob}) => <Toolbar>
  <StockBalanceExport />
  <Button onClick={handleNewJob} variant='raised' color='primary' className={classes.button}>
    <AddIcon />
      Create New Job
  </Button>
</Toolbar>

export default withStyles(styles)(JobListMenuBar)



// WEBPACK FOOTER //
// ./src/jobs/JobListMenuBar.js